"use strict";
// component-camapignCalcPanel.js
(function ($) {
    /**
     * Gravity Wiz // Gravity Forms // Disable Submission when Pressing Enter
     * http://gravitywiz.com/disable-submission-when-pressing-enter-for-gravity-forms/
     */
    $(document).on('keypress', '.gform_wrapper', function (e) {
        var code = e.keyCode || e.which;
        if (code == 13 && !$(e.target).is('textarea,input[type="submit"],input[type="button"]')) {
            e.preventDefault();
            return false;
        }
    });
    function formatCurrency(val) {
        return parseFloat(val).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    }
    function calcPanelInteractions() {
        // When you click on the Calculate button ...
        $('.calcPanel__calc__calculator .buttonCalc').on('click', function () {
            // find the resutls in the form ...
            var resultRepayment = $(this).closest('form').find('.calc-resultRepayment').find('input[type="text"]').val();
            var resultBorrow = $(this).closest('form').find('.calc-resultBorrow').find('input[type="text"]').val();
            var resultLtv = $(this).closest('form').find('.calc-resultLtv').find('input[type="text"]').val();
            var resultVar = $(this).closest('form').find('.calc-resultVar').find('input').val();
            var resultApr = $(this).closest('form').find('.calc-resultApr').find('input').val();
            // update the results div with these value ...
            $('.calcPanel__resultFigure .calc-resultRepayment').text('€' + formatCurrency(resultRepayment));
            $('.calcPanel__resultFigure .calc-resultBorrow').text('€' + formatCurrency(resultBorrow));
            $('.calcPanel__resultNotes .calc-resultLtv').text(resultLtv);
            $('.calcPanel__resultNotes .calc-resultVar').text(resultVar);
            $('.calcPanel__resultNotes .calc-resultApr').text(resultApr);
            // If on desktop or tablet ...
            if ($('body').hasClass('full')) {
                var b = $(this);
                if ($('.calcPanel__results').is(':visible')) {
                    // Remove border radius from left side of calculator
                    $('.calcPanel__calc').css({
                        'border-top-left-radius': '0',
                        'border-bottom-left-radius': '0'
                    });
                    var calcHeight = $('.calcPanel__calc').outerHeight();
                    // Ensure results height is the same as calculator height
                    $('.calcPanel__results').css('height', calcHeight);
                    $('.calcPanel__result').css('height', calcHeight);
                    b.removeClass('default').addClass('altered');
                    // change button text to read Recalculate
                    b.html('Recalculate');
                    // Animate result container in from the left and fade in results content
                    $('.calcPanel__results').animate({
                        'opacity': 1
                    }, 500, function () {
                        $('.calcPanel__results').find('.js-fade').fadeIn();
                    });
                }
            }
            // if on mobile ....
            else {
                $('.calcPanel__results').animate({
                    'opacity': 1
                }, 500, function () {
                    $('.calcPanel__results').slideDown();
                    $('.calcPanel__results').find('.js-fade').fadeIn();
                });
                $('html,body').animate({
                    scrollTop: $('.calcPanel__results').offset().top
                }, 1000);
            }
        });
        $('.calcPanel__calc__calculator input').on('propertychange change click keyup input paste', function () {
            // find the resutls in the form ...
            var resultRepayment = $(this).closest('form').find('.calc-resultRepayment').find('input[type="text"]').val();
            var resultBorrow = $(this).closest('form').find('.calc-resultBorrow').find('input[type="text"]').val();
            var resultLtv = $(this).closest('form').find('.calc-resultLtv').find('input[type="text"]').val();
            var resultVar = $(this).closest('form').find('.calc-resultVar').find('input').val();
            var resultApr = $(this).closest('form').find('.calc-resultApr').find('input').val();
            // update the results div with these value ...
            $('.calcPanel__resultFigure .calc-resultRepayment').text('€' + formatCurrency(resultRepayment));
            $('.calcPanel__resultFigure .calc-resultBorrow').text('€' + formatCurrency(resultBorrow));
            $('.calcPanel__resultNotes .calc-resultLtv').text(resultLtv);
            $('.calcPanel__resultNotes .calc-resultVar').text(resultVar);
            $('.calcPanel__resultNotes .calc-resultApr').text(resultApr);
        });
        // Check height of container after conditional questions are asked ...
        $('.calcPanel__calc__calculator').on('propertychange change click keyup input paste', function () {
            if ($('body').hasClass('full')) {
                if ($('.calcPanel__results').is(':visible')) {
                    // Ensure results height is the same as calculator height
                    var calcHeight = $('.calcPanel__calc').outerHeight();
                    $('.calcPanel__results').css('height', calcHeight);
                    $('.calcPanel__result').css('height', calcHeight);
                }
            }
        });
        // Close Panel and revert everything back to default state
        $('.calcPanel__results .calcPanel__close').on('click', function () {
            $('.calcPanel__results').find('.js-fade').fadeOut();
            if ($('body').hasClass('full')) {
                $('.calcPanel__results').animate({
                    opacity: '0'
                }, 750, function () {
                    $('.calcPanel__results').css('height', 0);
                    $('.calcPanel__result').css('height', 0);
                    $('.calcPanel__results').find('.js-fade').fadeOut();
                    $('.calcPanel__calc__calculator .buttonCalc').html('Calculate');
                    $('.calcPanel__calc__calculator .buttonCalc').removeClass('default').addClass('altered');
                    if ($('.calcPanel__calc__calculator__apply').is(':visible')) {
                        $('.calcPanel__calc__calculator__apply').hide();
                        $('.calcPanel__calc__calculator__calc').fadeIn();
                    }
                });
            }
            // if on mobile ...
            else {
                $('.calcPanel__results').slideUp();
                $('.calcPanel__results').animate({
                    'opacity': 0
                }, 500, function () {
                    $('.calcPanel__results').find('.js-fade').fadeOut();
                });
            }
        });
        // Show second part of form when you click apply
        $('.calcPanel__results .calcPanel__applyCTA button').on('click', function () {
            $(this).fadeOut();
            var calcHeight = $('.calcPanel__calc__calculator__calc').height() + 21;
            $('.calcPanel__calc__calculator__calc').hide();
            // if not on mobile ..
            if ($('body').hasClass('full')) {
                var applyHeight = $('.calcPanel__calc__calculator__apply').height() + 43;
                if (applyHeight > calcHeight) {
                    $('.calcPanel__results').css('height', applyHeight);
                    $('.calcPanel__result').css('height', applyHeight);
                }
                else {
                    $('.calcPanel__calc__calculator__apply').css('height', calcHeight);
                }
            }
            // if on mobile ...
            else {
                $('html,body').animate({
                    scrollTop: $('.calcPanel__calc').offset().top
                }, 1000);
            }
            $('.calcPanel__calc__calculator__apply').fadeIn();
        });
        // Submit the application
        $('.calcPanel__calc__calculator__actions .apply').on('click', function () {
            if ($('body').hasClass('full')) {
                $('.calcPanel__results').animate({
                    opacity: '0',
                }, 750, function () {
                    $('.calcPanel__results').find('.js-fade').fadeOut();
                });
            }
            // if on mobile ...
            else {
                $('.calcPanel__results').slideUp();
            }
        });
    }
    calcPanelInteractions();
    function scrollAfterSubmit() {
        $(document).ready(function () {
            $(document).bind('gform_confirmation_loaded', function () {
                // This will reposition scroll to where the calculator intro is after submit
                if ($('body').hasClass('full')) {
                    $('body').animate({
                        scrollTop: $('.calcPanel__calc__intro').offset().top
                    }, 'slow');
                }
                else {
                    $('body').animate({
                        scrollTop: $('.calcPanel__calc').offset().top - 20
                    }, 'slow');
                }
            });
        });
    }
    scrollAfterSubmit();
})(jQuery);
